import { CRow, CCol, CCard, CCardBody, CCardTitle, CFormInput } from '@coreui/react'
import React from 'react'
import userApi from 'src/utils/axios';;
import ConfigData from './../../../config/constant.json'
import { Table } from 'react-bootstrap'
import moment from 'moment';
import DeleteDailog from '../Master/DeleteDailog';
import ReactPaginate from 'react-paginate';
import Toaster from 'src/views/shared/Toaster';
import { debounce } from 'lodash';
import LoadingScreen from 'src/views/shared/Loading';

const AllScheduleMeetings = () => {

    const [loader, setloader] = React.useState(true);
    const [mentorData, setMentorData] = React.useState([])
    const [error, setError] = React.useState(false)
    const [toast, addToast] = React.useState(false)


    let addToaster = (toast) => {
        addToast(toast)
        setTimeout(() => {
            addToast(false)
        }, 3000)
    }

    React.useEffect(() => {
        getInitialData();
    }, [])



    const [deleteModal, setDeleteModal] = React.useState(false)
    const [deleteData, setDeleteData] = React.useState(false);
    const [mentorid, setMentorId] = React.useState(false);
    const [pages, setPages] = React.useState(1);

    const handleDeleteModal = (item) => {
        setMentorId(item._id)
        setDeleteData(item)
        setDeleteModal(true)
    }

    const handleDelete = async () => {
        try {

            let response = await userApi.post(`${ConfigData.SERVER_URL}/admin/mentor/deletescheduledmeeting`, { mentorid })
            if (response.data.status = true) {
                setMentorData(mentorData.filter((mode) => { return mode._id !== deleteData._id }))
                setDeleteModal(false)
            }
            let toast = {
                "status": true,
                "body": response.data.message,
                "message": "Success"
            }
            addToaster(toast)


        } catch (error) {
            console.log(error);
            let toast = {
                "status": false,
                "body": error.message,
                "message": "Failed"
            }
            addToaster(toast)
        }
    }

    // Pagination logic
    const itemsPerPage = 20;
    const [pageCount, setPageCount] = React.useState(0);
    const [itemOffset, setItemOffset] = React.useState(0);

    React.useMemo(() => {
        setPageCount(Math.ceil(pages / itemsPerPage));
    }, [itemOffset, itemsPerPage, pages]);

    const getInitialData = async () => {
        try {
            const response = await userApi.get(`${ConfigData.SERVER_URL}/admin/mentor/getAllScheduleMeetings`)
            if (response.data.status === true) {
                setMentorData(response.data.data)
                setPages(response.data.pages)
                setloader(false)
            }
        } catch (error) {
            setloader(false)
            setError(`${error.message} :(`)
            let toast = {
                "status": false,
                "body": error.message,
                "message": "Failed"
            }
            addToaster(toast)
        }
    }

    const handlePageClick = async (event) => {
        try {
            const newOffset = (event.selected * itemsPerPage) % pages;
            setItemOffset(newOffset);
            const response = await userApi.get(`${ConfigData.SERVER_URL}/admin/mentor/getAllScheduleMeetings?page=${event.selected}&limit=${itemsPerPage}`);
            setMentorData(response.data.data)

        } catch (error) {
            setError(`${error.message} :(`);
            let data = {
                "status": false,
                "body": error.message,
                "message": "Failed"
            }
            addToaster(data);
        }

    }

    const handleSearch = debounce(async (event) => {
        try {
            setloader(true)
            let search = event.target.value;
            const response = await userApi.get(`${ConfigData.SERVER_URL}/admin/mentor/searchMentorMeetings?search=${search}`)
            if (response.data.data.length > 0) {
                setMentorData(response.data.data);
                setloader(false);
            } else {
                setMentorData([]);
                setloader(false);
            }
        } catch (error) {
            setloader(false)
            console.log(error);
        }

    }, 400);


    return (
        <>
            <CRow>
                <CCol sm={12}>
                    <CCard style={{ background: "#34962d" }}>
                        <CCardBody>
                            <CRow>
                                <CCol sm={4}> <CCardTitle style={{ color: "white" }}>All Mentor/Mentee Meetings</CCardTitle></CCol>
                                <CCol sm={4}></CCol>
                                <CCol sm={4}> <CFormInput
                                    placeholder="Search"
                                    autoComplete="Search"
                                    onChange={handleSearch}
                                /></CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
            <br />

            {
                loader &&
                <LoadingScreen ></LoadingScreen>
            }

            {
                deleteModal &&
                <DeleteDailog
                    visible={deleteModal}
                    onClose={() => setDeleteModal(false)}
                    data={deleteData}
                    delete={handleDelete}
                    addToaster={addToaster}
                />
            }
            { !loader &&
                mentorData.length > 0 &&
                <div style={{
                    display: "flex",
                    justifyContent: "flex-start",
                }} >
                    <span style={{ color: "black", fontSize:20 }}>Filtered Meeting count : {pages}</span>
                </div>

            }
            {
                loader == false && mentorData.length > 0 &&
                <>
                    <CRow>
                        <CCol sm={12}>
                            <CCard>
                                <CCardBody>
                                    <Table responsive bordered hover size="lg">

                                        <thead>
                                            {/* Table Header align center */}
                                            <tr style={{ textAlign: "center", verticalAlign: "middle", }}>
                                                <th>Sr. No</th>
                                                <th>Mentor Name</th>
                                                <th>Mentee Name</th>
                                                <th>Meeting Link</th>
                                                <th>Meeting Date/Time</th>
                                                <th>Status</th>
                                                <th >Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {

                                                mentorData.map((item, index) => (
                                                    <tr key={item._id} style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                        <td>{index + 1 + itemOffset}</td>
                                                        <td>{item.mentor_app_id.name}</td>
                                                        <td>{item.user_id.name}</td>
                                                        <td><a target='_blank' href={item.link}>{item.link}</a></td>
                                                        <td>
                                                            {
                                                                moment(item.date)
                                                                    .format('DD-MM-YYYY')
                                                            }
                                                            &nbsp;||&nbsp;
                                                            {
                                                                moment(item.time)
                                                                    .format('hh:mm a')
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                moment(item.date) > moment() ?
                                                                    <span style={{
                                                                        color: "green",
                                                                        fontWeight: "bold"
                                                                    }} className="badge badge-success">Upcoming</span>
                                                                    :
                                                                    <span style={{
                                                                        color: "red",
                                                                        fontWeight: "bold"
                                                                    }} className="badge badge-danger">Completed</span>
                                                            }
                                                        </td>
                                                        <td className="text-center">
                                                            <button onClick={() => handleDeleteModal(item)} type="submit" className="btn btn-outline-danger">Delete</button>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </CCardBody>

                            </CCard>
                        </CCol>
                    </CRow>

                    <CRow>
                        <CCol sm={12}>
                            <ReactPaginate
                                previousLabel={"previous"}
                                nextLabel={"next"}
                                breakLabel={"..."}
                                pageCount={pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={3}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination justify-content-center"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                previousClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextClassName={"page-item"}
                                nextLinkClassName={"page-link"}
                                breakClassName={"page-item"}
                                breakLinkClassName={"page-link"}
                                activeClassName={"active"}
                            />
                        </CCol>
                    </CRow>


                </>
            }
            {
                mentorData.length == 0 && loader == false &&
                <div className="text-center">
                    <h3>No Data Found</h3>
                </div>
            }
            {
                error &&
                <div className="text-center">
                    <h3>{error}</h3>
                </div>
            }
            {
                toast &&
                <Toaster message={toast.message} status={toast.status} body={toast.body} ></Toaster>
            }

        </>
    );
}

export default AllScheduleMeetings;